import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { PublicWorkOrderFormUnsavedChangesGuard } from '@vendasta/work-order';
import baseTranslation from '../assets/i18n/en_devel.json';
import { OrderRecipientAuthGuard } from './OrderRecipientAuthGuard';
import { WEBLATE_COMPONENT_NAME } from './constants';
import { NavigationModule } from './navigation/navigation.module';
import { NotificationAuthGuard } from './notification-settings/notification-mail/notification-auth-guard';
import { VBCNotificationsModule } from './notifications/notifications.module';
import { UnsubscribeComponent } from './notifications/unsubscribe.component';
import { PublicFulfillmentOrderAuthGuard } from './public-fulfillment-order-auth-guard';
import { PublicSignupComponent } from './public-signup/public-signup.component';
import { PublicSignUpModule } from './public-signup/public-signup.module';
import { OrderApprovePageComponent } from './public/order-approve-page/order-approve-page.component';
import { PublicFulfillmentFormComponent } from './public/public-fulfillment-form/public-fulfillment-form.component';
import { PublicSalesOrderModule } from './public/public-sales-order.module';
import { SocialConnectionsService } from './social-connections/social-connections.service';

// prefix: public/
const publicRoutes: Routes = [
  { path: 'notifications/unsubscribe', component: UnsubscribeComponent },
  {
    path: 'notifications/settings/:accountGroupId/:userId',
    loadChildren: () =>
      import('./notification-settings/notification-mail.module').then((m) => m.NotificationMailModule),
    canActivate: [NotificationAuthGuard],
  },
  {
    path: 'business/:partnerId/:marketId/sign-up',
    component: PublicSignupComponent,
  },
  {
    path: 'orders/:orderId',
    component: OrderApprovePageComponent,
    data: {
      legacy: true,
    },
    canActivate: [OrderRecipientAuthGuard],
  },
  {
    path: 'account/location/:accountGroupId/proposals',
    loadChildren: () => import('./proposal-viewer/proposal-viewer.module').then((m) => m.ProposalViewerModule),
    canActivate: [OrderRecipientAuthGuard],
  },
  /* Used for screenshots and PDFs for Proposal Builder (not all documents have a recipient / account yet) */
  {
    path: 'proposals',
    loadChildren: () => import('./proposal-viewer/proposal-viewer.module').then((m) => m.ProposalViewerModule),
    canActivate: [OrderRecipientAuthGuard],
  },
  {
    path: 'account/location/:accountGroupId/orders/approve/:orderId',
    component: OrderApprovePageComponent,
    canActivate: [OrderRecipientAuthGuard],
  },
  {
    path: 'account/location/:accountGroupId/orders/fulfillment-forms/:orderId',
    component: PublicFulfillmentFormComponent,
    canActivate: [PublicFulfillmentOrderAuthGuard],
    canDeactivate: [PublicWorkOrderFormUnsavedChangesGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(publicRoutes),
    NavigationModule,
    VBCNotificationsModule,
    PublicSignUpModule,
    PublicSalesOrderModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
  ],
  providers: [
    SocialConnectionsService,
    OrderRecipientAuthGuard,
    NotificationAuthGuard,
    PublicFulfillmentOrderAuthGuard,
    DatePipe,
  ],
})
export class PublicAppModule {}
